import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module-login';
const platform = platformBrowserDynamic();
platform.bootstrapModule(AppModule);